/**
 * מלון מעסקת LDS — תומך ב־fullDeal / SOAP עם שינויי רישיות.
 * @param {object} pkg
 * @returns {object|null}
 */
export function getLdsHotelFromPackage(pkg) {
  if (!pkg || typeof pkg !== "object") return null;
  const full = pkg.fullDeal || pkg;
  const h =
    full?.hotel ||
    full?.Hotel ||
    pkg.hotel ||
    pkg.Hotel;
  return h && typeof h === "object" ? h : null;
}

import { formatIsraelDisplayDate } from "./DatesHelpers";

/**
 * DD/MM/YYYY ל־LDS; אם כבר בפורמט — מנרמל ריפוד.
 * @param {string} [value]
 * @returns {string|undefined}
 */
export function toLdsDdMmYyyy(value) {
  if (value == null || String(value).trim() === "") return undefined;
  const t = String(value).trim();
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(t)) {
    const [d, m, y] = t.split("/");
    return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y}`;
  }
  const formatted = formatIsraelDisplayDate(t);
  return formatted || t;
}
